import { useEffect, useState } from 'react';
import PiPrice from '../components/PiPrice';
import { t } from '../i18n';
import ReviewBox, { VerifiedBadge } from '../components/ReviewBox';

const API = '/api/academy';
function authHeaders() {
  const token = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Token ${token}` } : {}) };
}
const C = { bg: '#FCFCFA', surface: '#fff', border: '#E3E1D9', text: '#2C2C2A', muted: '#5F5E5A', primary: '#0F6E56' };
const inp = { width: '100%', padding: '9px 11px', fontSize: 14, border: `0.5px solid ${C.border}`, borderRadius: 8, boxSizing: 'border-box', marginBottom: 10 };
const lbl = { fontSize: 12, color: C.muted, display: 'block', marginBottom: 4 };
const btn = { padding: '9px 16px', fontSize: 13, fontWeight: 600, border: 'none', borderRadius: 8, background: C.primary, color: '#fff', cursor: 'pointer' };
const btnGhost = { ...btn, background: '#fff', color: C.text, border: `0.5px solid ${C.border}` };
const tabBtn = (active) => ({ padding: '8px 14px', fontSize: 13, fontWeight: 500, border: 'none', borderBottom: active ? `2px solid ${C.primary}` : '2px solid transparent', background: 'transparent', color: active ? C.primary : C.muted, cursor: 'pointer' });

export default function Tutoring() {
  const [tab, setTab] = useState('find');
  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: '1.5rem', fontFamily: 'sans-serif', background: C.bg, minHeight: '100vh' }}>
      <h1 style={{ fontSize: 22, margin: '0 0 10px' }}>🎓 {t('tut_live_tutoring')}</h1>
      <div style={{ display: 'flex', gap: 4, borderBottom: `0.5px solid ${C.border}`, marginBottom: 16 }}>
        <button style={tabBtn(tab === 'find')} onClick={() => setTab('find')}>{t('tut_find_tutor')}</button>
        <button style={tabBtn(tab === 'sessions')} onClick={() => setTab('sessions')}>{t('tut_my_sessions')}</button>
        <button style={tabBtn(tab === 'become')} onClick={() => setTab('become')}>{t('tut_become_tutor')}</button>
      </div>
      {tab === 'find' && <FindTutor />}
      {tab === 'sessions' && <MySessions />}
      {tab === 'become' && <BecomeTutor />}
    </div>
  );
}

function FindTutor() {
  const [tutors, setTutors] = useState(null);
  const [subject, setSubject] = useState('');
  const [booking, setBooking] = useState(null);

  const load = () => fetch(`${API}/tutors/?subject=${encodeURIComponent(subject)}`).then((r) => r.json()).then((d) => setTutors(d.tutors || []));
  useEffect(() => { load(); }, []); // eslint-disable-line

  if (booking) return <BookSession tutor={booking} onBack={() => setBooking(null)} />;
  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
        <input style={{ ...inp, marginBottom: 0 }} placeholder={t('tut_subject')} value={subject} onChange={(e) => setSubject(e.target.value)} />
        <button style={btnGhost} onClick={load}>{t('search')}</button>
      </div>
      {tutors === null && <p style={{ fontSize: 13, color: C.muted }}>{t('loading')}</p>}
      {tutors && tutors.length === 0 && <p style={{ fontSize: 13, color: C.muted }}>{t('tut_no_tutors')}</p>}
      {tutors && tutors.map((tu) => (
        <div key={tu.id} style={{ background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: '1rem', marginBottom: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ fontSize: 15, fontWeight: 600 }}>@{tu.username}</span>
                <VerifiedBadge module="tutor" objectId={tu.id} />
              </div>
              <p style={{ fontSize: 13, color: C.muted, margin: '2px 0' }}>{tu.headline}</p>
              {tu.subjects && <p style={{ fontSize: 12, color: C.text, margin: '2px 0' }}>📚 {tu.subjects}</p>}
              {tu.availability_note && <p style={{ fontSize: 12, color: C.muted, margin: '2px 0' }}>🕐 {tu.availability_note}</p>}
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ fontSize: 16, fontWeight: 700, color: C.primary }}><PiPrice pi={tu.hourly_rate_pi} /><span style={{ fontSize: 11, color: C.muted }}>{t('tut_per_hour')}</span></div>
              <button style={{ ...btn, marginTop: 6 }} onClick={() => setBooking(tu)}>{t('tut_book_session')}</button>
            </div>
          </div>
          {tu.bio && <p style={{ fontSize: 13, color: C.text, margin: '8px 0 0' }}>{tu.bio}</p>}
          <ReviewBox module="tutor" objectId={tu.id} objectTitle={tu.username} />
        </div>
      ))}
    </div>
  );
}

function BookSession({ tutor, onBack }) {
  const [form, setForm] = useState({ subject: '', topic: '', scheduled_datetime: '', duration_minutes: 60 });
  const [msg, setMsg] = useState('');
  const price = (tutor.hourly_rate_pi * (form.duration_minutes / 60)).toFixed(2);

  const book = async () => {
    if (!form.scheduled_datetime) { setMsg(t('tut_date_time') + ' ?'); return; }
    const res = await fetch(`${API}/tutoring/book/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ tutor_id: tutor.id, ...form }) });
    const d = await res.json();
    if (!d.success) { setMsg(d.error || 'Failed'); return; }
    if (!window.Pi) { setMsg('Pi Browser mein kholein'); return; }
    if (window.xpertPayConfirm && !(await window.xpertPayConfirm({ amount: d.price_pi, memo: 'Tutoring session with @' + tutor.username }))) return;
    await window.Pi.authenticate(['username', 'payments'], () => {});
    window.Pi.createPayment(
      { amount: d.price_pi, memo: 'Tutoring session', metadata: { type: 'tutoring', session_id: d.session_id } },
      {
        onReadyForServerApproval: () => {},
        onReadyForServerCompletion: (paymentId, txid) => {
          fetch(`${API}/tutoring/${d.session_id}/pay-complete/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ payment_id: paymentId, txid }) })
            .then(() => { alert('✅ Session booked! Check "My Sessions" for the video link.'); onBack(); });
        },
        onCancel: () => setMsg('Payment cancelled'),
        onError: () => setMsg('Payment error'),
      }
    );
  };

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <div style={{ background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: '1.2rem' }}>
      <button onClick={onBack} style={{ ...btnGhost, marginBottom: 12 }}>← {tutor.username}</button>
      <label style={lbl}>{t('tut_subject')}</label><input style={inp} value={form.subject} onChange={set('subject')} placeholder={tutor.subjects} />
      <label style={lbl}>{t('tut_topic')}</label><textarea style={{ ...inp, minHeight: 60 }} value={form.topic} onChange={set('topic')} />
      <label style={lbl}>{t('tut_date_time')}</label><input type="datetime-local" style={inp} value={form.scheduled_datetime} onChange={set('scheduled_datetime')} />
      <label style={lbl}>{t('tut_duration')}</label>
      <select style={inp} value={form.duration_minutes} onChange={set('duration_minutes')}>
        <option value={30}>30</option><option value={60}>60</option><option value={90}>90</option><option value={120}>120</option>
      </select>
      <div style={{ fontSize: 18, fontWeight: 700, color: C.primary, margin: '6px 0 12px' }}>{price} π</div>
      {msg && <p style={{ fontSize: 13, color: '#A32D2D' }}>{msg}</p>}
      <button style={btn} onClick={book}>{t('tut_confirm_pay')}</button>
    </div>
  );
}

function MySessions() {
  const [sessions, setSessions] = useState(null);
  const load = () => fetch(`${API}/tutoring/mine/`, { headers: authHeaders() }).then((r) => r.json()).then((d) => setSessions(d.sessions || []));
  useEffect(() => { load(); }, []); // eslint-disable-line

  const act = async (id, action) => {
    await fetch(`${API}/tutoring/${id}/action/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ action }) });
    load();
  };

  if (!localStorage.getItem('token')) return <p style={{ fontSize: 13 }}>{t('cv_please_login')}</p>;
  if (sessions === null) return <p style={{ fontSize: 13, color: C.muted }}>{t('loading')}</p>;
  if (sessions.length === 0) return <p style={{ fontSize: 13, color: C.muted }}>{t('tut_no_sessions')}</p>;
  const statusLabel = { requested: t('tut_requested'), confirmed: t('tut_confirmed'), completed: t('tut_completed'), cancelled: t('tut_cancelled') };

  return (
    <div>
      {sessions.map((s) => (
        <div key={s.id + s.role} style={{ background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: '1rem', marginBottom: 10 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ fontSize: 14, fontWeight: 600 }}>{s.role === 'student' ? `@${s.tutor}` : `@${s.student}`}</span>
            <span style={{ fontSize: 12, fontWeight: 600, color: s.status === 'confirmed' ? C.primary : C.muted }}>{statusLabel[s.status] || s.status}</span>
          </div>
          <p style={{ fontSize: 13, color: C.text, margin: '4px 0' }}>{s.subject}{s.topic ? ` — ${s.topic}` : ''}</p>
          <p style={{ fontSize: 12, color: C.muted, margin: '2px 0' }}>{new Date(s.scheduled_datetime).toLocaleString()} · {s.duration_minutes} min · <PiPrice pi={s.price_pi} /></p>
          {s.status === 'confirmed' && (
            <a href={`https://meet.jit.si/${s.room_code}`} target="_blank" rel="noreferrer" style={{ ...btn, display: 'inline-block', textDecoration: 'none', marginTop: 6 }}>🎥 {t('tut_join_call')}</a>
          )}
          <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
            {s.role === 'tutor' && s.status === 'confirmed' && <button style={{ ...btnGhost, fontSize: 12, padding: '5px 12px' }} onClick={() => act(s.id, 'complete')}>{t('tut_mark_complete')}</button>}
            {s.status !== 'completed' && s.status !== 'cancelled' && <button style={{ ...btnGhost, fontSize: 12, padding: '5px 12px', color: '#A32D2D' }} onClick={() => act(s.id, 'cancel')}>{t('tut_cancel_session')}</button>}
          </div>
          {s.status === 'completed' && s.role === 'student' && <ReviewBox module="tutor" objectId={s.id} objectTitle={s.tutor} />}
        </div>
      ))}
    </div>
  );
}

function BecomeTutor() {
  const [form, setForm] = useState(null);
  const [msg, setMsg] = useState('');
  useEffect(() => {
    fetch(`${API}/tutors/mine/`, { headers: authHeaders() }).then((r) => r.json()).then((d) => {
      setForm(d.exists ? d : { headline: '', subjects: '', bio: '', hourly_rate_pi: 1, availability_note: '', languages: '', pi_wallet_address: '' });
    });
  }, []);
  if (!localStorage.getItem('token')) return <p style={{ fontSize: 13 }}>{t('cv_please_login')}</p>;
  if (!form) return <p style={{ fontSize: 13, color: C.muted }}>{t('loading')}</p>;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const save = async () => {
    const res = await fetch(`${API}/tutors/mine/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify(form) });
    const d = await res.json();
    setMsg(d.success ? '✅ Saved' : (d.error || 'Failed'));
  };
  return (
    <div style={{ background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: '1.2rem', maxWidth: 500 }}>
      <label style={lbl}>{t('tut_headline')}</label><input style={inp} value={form.headline} onChange={set('headline')} placeholder="Math & Physics tutor" />
      <label style={lbl}>{t('tut_subjects')}</label><input style={inp} value={form.subjects} onChange={set('subjects')} placeholder="Math, Physics, Chemistry" />
      <label style={lbl}>{t('bio_label')}</label><textarea style={{ ...inp, minHeight: 60 }} value={form.bio} onChange={set('bio')} />
      <label style={lbl}>{t('tut_hourly_rate')}</label><input type="number" style={inp} value={form.hourly_rate_pi} onChange={set('hourly_rate_pi')} />
      <label style={lbl}>{t('tut_availability')}</label><input style={inp} value={form.availability_note} onChange={set('availability_note')} placeholder="Mon-Fri evenings" />
      <label style={lbl}>{t('tut_languages')}</label><input style={inp} value={form.languages} onChange={set('languages')} placeholder="Urdu, English" />
      {msg && <p style={{ fontSize: 13, color: C.primary }}>{msg}</p>}
      <button style={btn} onClick={save}>{t('tut_save_profile')}</button>
    </div>
  );
}
